import BaseModel from "./BaseModel";
import StudentBaseModel from "./StudentBaseModel";
import StudentModel from "./StudentModel";

export default class ActiveRequestGroupModel extends BaseModel {
  all_affected_students_ids?: Number[];
  remianing_students?: StudentModel[];
  remianing_students_ids?: Number[];
  resolved_students_ids?: Number[];
  status?: string;
  constructor(arg: any) {
    super(arg);
    this.all_affected_students_ids = arg.all_affected_students_ids;
    this.remianing_students = StudentBaseModel.fromApiResponse(arg.remianing_students);
    this.remianing_students_ids= arg.remianing_students_ids;
    this.resolved_students_ids= arg.resolved_students_ids;
    this.status= arg.status;
  }
}
